<template>
  <div class="pages">
    <Header title="" :show-back="true" />
    <div class="video-info">
      <video
        id="video"
        :src="videoUrl"
        class="video-obj"
        autoplay
        controls
        type="video/mov"
        preload="yes"
        poster="../../assets/images/THEX-video-01.jpg"
      >
        Video player not available.
      </video>
    </div>
  </div>
</template>

<script>
import Header from '@/components/header'
import activityApi from '@/api/activity'
export default {
  name: 'TheXVideo',
  components: {
    Header
  },
  mounted () {
    const video = document.getElementById('video')
    video.play()
    document.addEventListener('WeixinJSBridgeReady', () => {
      // this.videoContext.play()
      video.play()
    }, false)
    this.viewIncrease()
  },
  data () {
    return {
      videoUrl: this.$route.query.target
    }
  },
  computed: {
  },
  methods: {
    viewIncrease () {
      const data = {
        contentId: this.$route.query.contentId || ''
      }
      activityApi.viewIncrease(data).then(res => {
        if (res.data.resultCode === '0') {
          console.log('increase')
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.pages {
  height: calc(100% - 46px);
}
.video-info {
  height: 100%;
  padding-top: 46px;
}
.video-obj {
  width: 100%;
}
</style>
